(function () {
    pagination(false);
})();

/*function trackPageVisit() {
    // Получаем элемент с ID 'post-data'
    const postDataElement = document.getElementById('post-data');

    // Проверяем, существует ли элемент и есть ли у него атрибут data-id
    if (postDataElement && postDataElement.getAttribute('data-id')) {
        const postId = postDataElement.getAttribute('data-id'); // Получаем ID поста

        // Отправляем данные с помощью navigator.sendBeacon или fetch
        if (navigator.sendBeacon) {
            const data = new Blob([JSON.stringify({ id: postId })], {
                type: 'application/json'
            });
            navigator.sendBeacon('https://omgubuntu.ru/api/visit', data);
        } else {
            fetch('https://omgubuntu.ru/api/visit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: postId })
            }).catch((error) => console.error('Failed to track page visit', error));
        }
    } else {
        // Если элемента или атрибута нет, просто логируем это и продолжаем
        console.warn('post-data element or data-id attribute is not defined.');
    }
}

window.addEventListener('load', trackPageVisit);

function updateActivePages() {
    // Делаем запрос к API для получения ID активных страниц
    fetch('https://omgubuntu.ru/api/active_pages')
        .then(response => response.json())
        .then(data => {
            const activePages = data.active_pages;
            const activeIds = activePages.map(page => page.id); // Извлекаем ID

            // Проверяем, существует ли элемент с ID 'dynamic-ids'
            const dataContainer = document.getElementById('dynamic-ids');
            if (dataContainer) {
                dataContainer.setAttribute('data-ids', activeIds.join(',')); // Обновляем значения ID в data-атрибут
                console.log(`Updated data-ids: ${activeIds.join(',')}`); // Логируем обновлённые ID для проверки
            } else {
                console.warn('dynamic-ids element is not defined.');
            }
        })
        .catch(error => console.error('Failed to load active pages', error));
}

// Запуск функции после загрузки страницы и затем каждые 15 секунд
window.addEventListener('load', () => {
    updateActivePages(); // Первоначальное выполнение при загрузке страницы
    setInterval(updateActivePages, 15000); // Повторяем запрос каждые 15 секунд
});
*/